<div class="admin-container">
    <app-admin-sidebar></app-admin-sidebar>
    <app-admin-prompts></app-admin-prompts>
</div>